import React from "react";
import dayjs from "dayjs";

interface ViewRequestModalProps {
  initialData: any;
  onClose: () => void;
}

const ViewRequestModal: React.FC<ViewRequestModalProps> = ({ initialData, onClose }) => {
  return (
    <div className="modal fade" id="view_request_modal" tabIndex={-1} aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Request Details</h4>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onClose}
              id="close_view_request_modal"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <span className="text-muted fs-13 d-block mb-1">Center</span>
                  <p className="fs-14 fw-medium text-dark">{initialData?.center?.name || "N/A"}</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <span className="text-muted fs-13 d-block mb-1">Course</span>
                  <p className="fs-14 fw-medium text-dark">{initialData?.course?.name || "N/A"}</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <span className="text-muted fs-13 d-block mb-1">Requested Quantity</span>
                  <p className="fs-14 fw-medium text-dark">{initialData?.quantity}</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <span className="text-muted fs-13 d-block mb-1">Requested On</span>
                  <p className="fs-14 fw-medium text-dark">
                    {initialData?.requested_on ? dayjs(initialData.requested_on).format("DD MMM YYYY") : "N/A"}
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <span className="text-muted fs-13 d-block mb-1">Status</span>
                  <p className="fs-14 fw-medium text-dark">
                    <span className={`badge badge-soft-${initialData?.status === 'approved' ? 'success' : initialData?.status === 'rejected' ? 'danger' : 'warning'} d-inline-flex align-items-center`}>
                      <i className="ti ti-circle-filled fs-5 me-1"></i>
                      {initialData?.status ? initialData.status.charAt(0).toUpperCase() + initialData.status.slice(1) : "Unknown"}
                    </span>
                  </p>
                </div>
              </div>
              
              {initialData?.status !== 'pending' && (
                <>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <span className="text-muted fs-13 d-block mb-1">Reviewed By</span>
                      <p className="fs-14 fw-medium text-dark">{initialData?.reviewer?.username || "N/A"}</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <span className="text-muted fs-13 d-block mb-1">Reviewed On</span>
                      <p className="fs-14 fw-medium text-dark">
                        {initialData?.reviewed_on ? dayjs(initialData.reviewed_on).format("DD MMM YYYY") : "N/A"}
                      </p>
                    </div>
                  </div>
                  {initialData?.reviewer_note && (
                    <div className="col-md-12">
                      <div className="mb-3">
                        <span className="text-muted fs-13 d-block mb-1">Reviewer Note</span>
                        <div className="p-3 bg-light rounded">
                          <p className="fs-14 fw-medium text-dark mb-0">{initialData.reviewer_note}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light"
              data-bs-dismiss="modal"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewRequestModal;
